import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import _invert from "lodash/invert";

var _maritalStatusName, _educationStatusName, _accommodationTypeNam, _employmentTypeName, _carStatusName, _familyConnectionType, _borrowerSearchTypesN, _borrowerActionTypeNa, _borrowerActionTypeCo;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var USER_STATUS = {
  GUEST: 'guest',
  NEW: 'new',
  VERIFIED: 'verified',
  ACTIVE: 'active',
  BLOCKED: 'blocked'
};
export var USER_ROLES = {
  MASTER_ADMIN: 'master-admin',
  BULZI_ADMIN: 'bulzi-admin',
  RAPTORS_USER: 'raptors-user'
};
export var USER_ADMIN_ROLES = {
  OWNER: 'owner',
  MANAGER: 'manager',
  RECEPTION: 'reception',
  ARMORY: 'armory',
  INSTRUCTOR: 'instructor'
};
export var EXPERIENCE_LEVEL = {
  ROOKIE: 'rookie',
  BEGINNER: 'beginner',
  PRO: 'pro'
}; // NEW ENUMS

export var MARITAL_STATUS = {
  married: 1,
  unmarried: 2,
  coexistence: 3,
  divorced: 4,
  widow: 5
};
export var maritalStatusName = (_maritalStatusName = {}, _defineProperty(_maritalStatusName, MARITAL_STATUS.married, 'Женен/омъжена'), _defineProperty(_maritalStatusName, MARITAL_STATUS.unmarried, 'Неженен/неомъжена'), _defineProperty(_maritalStatusName, MARITAL_STATUS.coexistence, 'Съжителство без брак'), _defineProperty(_maritalStatusName, MARITAL_STATUS.divorced, 'Разведен/разведена'), _defineProperty(_maritalStatusName, MARITAL_STATUS.widow, 'Вдовец/вдовица'), _maritalStatusName);
export var maritalStatusNameSelect = Object.entries(_invert(maritalStatusName)).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      value = _ref2[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var EDUCATION_STATUS = {
  high: 1,
  secondary: 2,
  primary: 3,
  initial: 4
};
export var educationStatusName = (_educationStatusName = {}, _defineProperty(_educationStatusName, EDUCATION_STATUS.high, 'Висше'), _defineProperty(_educationStatusName, EDUCATION_STATUS.secondary, 'Средно'), _defineProperty(_educationStatusName, EDUCATION_STATUS.primary, 'Основно'), _defineProperty(_educationStatusName, EDUCATION_STATUS.initial, 'Начално'), _educationStatusName);
export var educationStatusNameSelect = Object.entries(_invert(educationStatusName)).map(function (_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      label = _ref4[0],
      value = _ref4[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var ACCOMMODATION_TYPE = {
  rent: 1,
  withParents: 2,
  ownHome: 3,
  ownHomeWithMortgage: 4,
  corporateHousing: 5,
  municipalDwelling: 6,
  other: 7
};
export var accommodationTypeName = (_accommodationTypeNam = {}, _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.rent, 'Под наем'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.withParents, 'При родители'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.ownHome, 'Собствено жилище'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.ownHomeWithMortgage, 'Собствено жилище с ипотека'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.corporateHousing, 'Фирмено жилище'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.municipalDwelling, 'Общинско жилище'), _defineProperty(_accommodationTypeNam, ACCOMMODATION_TYPE.other, 'Друго'), _accommodationTypeNam);
export var accommodationTypeNameSelect = Object.entries(_invert(accommodationTypeName)).map(function (_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      label = _ref6[0],
      value = _ref6[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var EMPLOYMENT_TYPE = {
  permanentContract: 1,
  fixedContract: 2,
  managementContract: 3,
  farmer: 4,
  soleTrader: 5,
  selfInsured: 6,
  selfEmployed: 7,
  noEmploymentContract: 8,
  workingAbroad: 9,
  civilContract: 10,
  retired: 10,
  workingPensioner: 11,
  selfInsuredPensioner: 12,
  unemployed: 13,
  student: 14,
  motherhood: 15,
  other: 16
};
export var employmentTypeName = (_employmentTypeName = {}, _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.permanentContract, 'Безсрочен ТД'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.fixedContract, 'Срочен ТД'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.managementContract, 'Договор за управление'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.farmer, 'Земеделски производител'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.soleTrader, 'ЕТ'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.selfInsured, 'Самоосигуряващ се'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.selfEmployed, 'Частна практика'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.noEmploymentContract, 'Без ТД'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.workingAbroad, 'Работещ в чужбина'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.civilContract, 'Граждански договор'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.retired, 'Пенсионер'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.workingPensioner, 'Работещ пенсионер'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.selfInsuredPensioner, 'Пенсионер СО'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.unemployed, 'Безработен'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.student, 'Студент'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.motherhood, 'В майчинство'), _defineProperty(_employmentTypeName, EMPLOYMENT_TYPE.other, 'Друго'), _employmentTypeName);
export var employmentTypeNameSelect = Object.entries(_invert(employmentTypeName)).map(function (_ref7) {
  var _ref8 = _slicedToArray(_ref7, 2),
      label = _ref8[0],
      value = _ref8[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var CAR_STATUS = {
  own: 1,
  family: 2,
  companyCar: 3,
  none: 4
};
export var carStatusName = (_carStatusName = {}, _defineProperty(_carStatusName, CAR_STATUS.own, 'Собствен'), _defineProperty(_carStatusName, CAR_STATUS.family, 'Семеен'), _defineProperty(_carStatusName, CAR_STATUS.companyCar, 'Служебен'), _defineProperty(_carStatusName, CAR_STATUS.none, 'Нямам'), _carStatusName);
export var carStatusNameSelect = Object.entries(_invert(carStatusName)).map(function (_ref9) {
  var _ref10 = _slicedToArray(_ref9, 2),
      label = _ref10[0],
      value = _ref10[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var FAMILY_CONNECTION_TYPE = {
  husbandWife: 1,
  familyPartner: 2,
  sonDaughter: 3,
  parent: 4,
  brotherSister: 5,
  relative: 6,
  friend: 7,
  colleague: 8
};
export var familyConnectionTypeName = (_familyConnectionType = {}, _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.husbandWife, 'Съпруг/съпруга'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.familyPartner, 'Семеен партньор'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.sonDaughter, 'Син/дъщеря'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.parent, 'Родител'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.brotherSister, 'Брат/сестра'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.relative, 'Роднина'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.friend, 'Приятел'), _defineProperty(_familyConnectionType, FAMILY_CONNECTION_TYPE.colleague, 'Колега'), _familyConnectionType);
export var familyConnectionTypeNameSelect = Object.entries(_invert(familyConnectionTypeName)).map(function (_ref11) {
  var _ref12 = _slicedToArray(_ref11, 2),
      label = _ref12[0],
      value = _ref12[1];

  return {
    label: label,
    value: Number(value)
  };
});
export var BORROWERS_SEARCH_TYPE = {
  name: 'name',
  id_number: 'id_number',
  phone: 'phone',
  area: 'area',
  city: 'city',
  address: 'address'
};
export var borrowerSearchTypesName = (_borrowerSearchTypesN = {}, _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.name, 'Име на клиент'), _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.id_number, 'ЕГН на клиент'), _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.phone, 'Телефон'), _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.area, 'Област'), _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.city, 'Град'), _defineProperty(_borrowerSearchTypesN, BORROWERS_SEARCH_TYPE.address, 'Адрес'), _borrowerSearchTypesN);
export var borrowerSearchTypesNameSelect = Object.entries(_invert(borrowerSearchTypesName)).map(function (_ref13) {
  var _ref14 = _slicedToArray(_ref13, 2),
      label = _ref14[0],
      value = _ref14[1];

  return {
    label: label,
    value: value
  };
});
export var borrowerCreditsCountSelect = [{
  label: '1',
  value: {
    min_count_credits: 1,
    max_count_credits: 1
  }
}, {
  label: '2',
  value: {
    min_count_credits: 2,
    max_count_credits: 2
  }
}, {
  label: '3-5',
  value: {
    min_count_credits: 3,
    max_count_credits: 5
  }
}, {
  label: '6-10',
  value: {
    min_count_credits: 6,
    max_count_credits: 10
  }
}, {
  label: '11 +',
  value: {
    min_count_credits: 11,
    max_count_credits: 0
  }
}];
export var hasActiveCreditsSelect = [{
  label: 'Да',
  value: 1
}, {
  label: 'Не',
  value: 0
}];
export var hasLatePaymentsSelect = [{
  label: 'Да',
  value: 1
}, {
  label: 'Не',
  value: 0
}];
export var BORROWER_ACTION_TYPE = {
  create_borrower: 'create_borrower',
  update_borrower: 'update_borrower',
  upload_id_card_images: 'upload_id_card_images',
  add_action: 'add_action',
  update_action: 'update_action'
};
export var borrowerActionTypeName = (_borrowerActionTypeNa = {}, _defineProperty(_borrowerActionTypeNa, BORROWER_ACTION_TYPE.create_borrower, 'СЪЗДАВАНЕ'), _defineProperty(_borrowerActionTypeNa, BORROWER_ACTION_TYPE.update_borrower, 'РЕДАКТИРАНЕ'), _defineProperty(_borrowerActionTypeNa, BORROWER_ACTION_TYPE.upload_id_card_images, 'КАЧВАНЕ НА ДОКУМЕНТИ'), _defineProperty(_borrowerActionTypeNa, BORROWER_ACTION_TYPE.add_action, 'ДОБАВЯНЕ НА ДЕЙСТВИЕ'), _defineProperty(_borrowerActionTypeNa, BORROWER_ACTION_TYPE.update_action, 'ОБНОВЯВАНЕ НА ДЕЙСТВИЕ'), _borrowerActionTypeNa);
export var borrowerActionTypeColorMap = (_borrowerActionTypeCo = {}, _defineProperty(_borrowerActionTypeCo, BORROWER_ACTION_TYPE.create_borrower, 'success'), _defineProperty(_borrowerActionTypeCo, BORROWER_ACTION_TYPE.update_borrower, 'info'), _defineProperty(_borrowerActionTypeCo, BORROWER_ACTION_TYPE.upload_id_card_images, 'orange'), _defineProperty(_borrowerActionTypeCo, BORROWER_ACTION_TYPE.add_action, 'green'), _defineProperty(_borrowerActionTypeCo, BORROWER_ACTION_TYPE.update_action, 'blue'), _borrowerActionTypeCo);